import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=3fe84e88&scoped=true"
import script from "./UserRegistration.vue?vue&type=script&lang=ts"
export * from "./UserRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe84e88",
  null
  
)

export default component.exports